/*******************************************************************************
 * Copyright     : Copyright (c)  2019 Honeywell Inc. All rights reserved.
 *                 This work contains trade secrets and confidential materials
 *                 of Honeywell Inc., and its use or disclosure in whole or in
 *                 part without express written permission of Honeywell Inc.
 *                 is prohibited.
 *
 * Name          : ReviewOrder.tsx
 *
 * Project Title : Checkout
 *
 * Description   : Initial version
 *
 * Company       : Honeywell Technology Solutions , Hyderabad
 *
 * @Author       : Grandhi Srinivas (E528634)
 *
 * @Date         : Jul 29, 2019
 *
 * @Version      : Version 1.0
 *
 * By            : Avanthi G (E860178)
 * On            : Aug 02, 2019
 * Description   : ProductList component added (ASDS-693).

 * By            : Archana P (E542450)
 * On            : Aug 05, 2019
 * Description   : Code Review Comments fixes (ASDS-691).

 * By            : Avanthi G (E860178)
 * On            : Aug 09, 2019
 * Description   : Connected ShippingInfoComponent to store (ASDS-956).

 * By            : Archana P (E542450)
 * On            : Aug 09, 2019
 * Description   : Review Order Page Dynamin Data for Sold To and Ship To (ASDS-952)
 *
 * By            : H352615
 * On            : Aug 13, 2019
 * Description   : Integrated with OrderSummary.tsx.
 *
 * By            : Grandhi Srinivas (E528634)
 * On            : Sep 12, 2019
 * Description   : Updated code as per ASDS-1169.
 *
 * By            : Madhu Gali
 * On            : Sep 19 2019
 * Description   : ASDS-165
 *
 * By            : sivateja. peram
 * On            : Sep 30 2019
 * Description   : ASDS-1288
 *
 * By            : Grandhi Srinivas (E528634)
 * On            : Oct 09, 2019
 * Description   : Updated code as per ASDS-1301.
 *
 * By            : sivateja. peram
 * On            : OCT 10 2019
 * Description   : updated back button actions
 *
 * Description   : Updated code as per ASDS-1301.
 * By            : H224423
 * On            : Oct 10, 2019
 * Description   : ASDS-1478 - Grid level resposnive changes and UI issue fixes
 *
 * By            : H224423
 * On            : Oct 21, 2019
 * Description   : ASDS-1548 changes.
 *
 * By            : H224423
 * On            : NOV 08, 2019
 * Description   : Implemented Order succes - order details with session storage.
 *
 * By            : H224423
 * On            : NOV 08, 2019
 * Description   : Addressed grid spacing issue.
 *
 * By            : E807958
 * On            : NOV 08 2019
 * Description   : ASDS-1671
 *
 * By            : Sandeep Raja
 * On            : Nov 20, 2019
 * Description   : ASDS-1643: Tax Service Exception Scenario
 *
 * By            : Sandeep Raja (E807238)
 * On            : Nov 27, 2019
 * Description   : ASDS-1948: Unable to fetch tax in My Cart Page
 *
 * By            : Deepthi (E844276)
 * On            : Dec 5, 2019
 * Description   : ASDS-1961: href link to T&C document
 *
 * By            : H224423
 * On            : Feb 13, 2019
 * Description   : ASDS-2055 Change account delete MSA APU product.
 *
 * By            : H224423
 * On            : Mar 12 2020
 * Description   : ASDS-2083 - Verbiage changes
 *
 * By            : Suresh Jaladi - E807958
 * On            : Mar 11, 2020
 * Description   : ASDS-1766
 *
 * By            : H224423
 * On            : Apr 03 2020
 * Description   : ASDS-2190 - API error handling changes
 *
 * By            : H224423
 * On            : Apr 07 2020
 * Description   : ASDS-2497 - SIT Issue fixes. Fixed Checbox text.
 *
 * By            : H422335
 * On            : Sep 07 2020
 * Description   : ASDS-2743 - Review Order UI Enhancements as part of APU Phase 2.
 *
 * By            : H422335
 * On            : Nov 30 2020
 * Description   : Changed the terms and conditions text above place order button.
 ******************************************************************************/

import * as React from 'react';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import {
    Grid,
    Card,
    Button,
    Checkbox,
    Notification,
} from '@scuf/common';
import '@scuf/common/honeywell/theme.css';
import './reviewOrder.css';
import '@scuf/styles/variables.scss';
import RouteConstants from '../constants/route-constants';
import RouteNames from '../constants/route-names';
import Layout from '../Layout/Layout';
import { connect } from 'react-redux';
import OrderSummery from '../OrderSummery/OrderSummery';
import ProductList from '../ProductList/ProductList';
import {
    IreviewOrderState, IreviewOrderProps, IBreadcrumbLink
} from '../utils/checkout-interfaces';
import PlaceOrderRequestActions from '../redux/actions/place-order-request-actions';
import ShippingAndBillingInfoComponent from './ShippingAndBillingInfoComponent';
import GenericLoader from '../Loader/Loader';
import TaxStatusMessage from '../OrderSummery/TaxStatusMessage';
import { CheckoutUILabels, CheckoutServiceURL } from '../constants/checkout-constants';
import API from '../API/api';
import { handleResponse, checkUnauthorizedUserError } from '../API/apiUtils';
import { logError } from '../../../utils/console-utility';
import { ContactUsMessage } from '../Common/ContactUsMessage';
import BreadcrumbComponent from '../BreadcrumbComponent/BreadcrumbComponent';
import ApplyCouponActions from '../redux/actions/apply-coupon-actions';
import ReviewOrderActions from '../redux/actions/review-order-actions';

export class ReviewOrder extends React.Component<IreviewOrderProps & RouteComponentProps, IreviewOrderState> {
    constructor(props: IreviewOrderProps & RouteComponentProps) {
        super(props);
        this.state = {
            open: false,
            hasClickOut: true,
            TnCStatus: false,
            TnCUrl: '',
            TnCErrorMsg: ''
        };
        this.placeOrder = this.placeOrder.bind(this);
        this.updatePlaceOrderButtonStatus = this.updatePlaceOrderButtonStatus.bind(this);
        this.getTermsConditionsUrl = this.getTermsConditionsUrl.bind(this);
    }

    componentDidUpdate(prevProps) {
        if (this.props.itemCount < 1) {
            // Navigating user to MyCart page when the cart is empty.
            this.props.history.push(RouteConstants.MY_CART);
        }

        if (
            typeof this.props.taxSuccessOrFailure !== "undefined" &&
            !this.props.taxSuccessOrFailure &&
            prevProps.taxSuccessOrFailure !== this.props.taxSuccessOrFailure
        ) {
            window.scroll(0, 0);
        }
    }
    componentDidMount() {
        this.getTermsConditionsUrl();
        this.props.insideReviewOrder(true);
    }

    async getTermsConditionsUrl() {
        const url = CheckoutServiceURL.GET_TERMS_CONDITION_URL;
        const response: any = await API.get(url)
            .then(handleResponse)
            .catch(error => checkUnauthorizedUserError(error, 'Error while fetching terms and condition url'));
        if (response) {
            this.setState({ TnCUrl: response.url });
        }
        else {
            logError('Error while fetching terms and condition url.');
        }
    }

    async placeOrder() {
        if (this.state.TnCStatus) {
            await this.props.placeOrderRequest();
            const response = await this.props.orderReference;
            if (response && 200 === response.status) {
                this.props.history.push(
                    {
                        pathname: RouteConstants.ORDER_SUCCESS,
                    });
            }
            else {
                this.props.history.push(
                    {
                        pathname: RouteConstants.ORDER_FAILURE,
                        state: { status: 'allow' }
                    });
            }
        } else {
            this.setState({ TnCErrorMsg: 'Please select this checkbox to confirm the terms and conditions.'});
        }
    }

    updatePlaceOrderButtonStatus(checkboxStatus) {
        this.setState({
            TnCStatus: checkboxStatus,
            TnCErrorMsg: ''
        });
    }
    errorContent = () => {
        let errorObj ;
        if ( (!this.props.isFetching && !this.props.isSuccess) || (!this.props.isFetchingCartList && !this.props.isSuccessCartList) ) {
          errorObj = (<Grid.Row data-testid="t-review-order-error-notification">
              <Grid.Column width={12}>
                <Notification
                  hasIcon={true}
                  title="There is an error in processing your request."
                  severity="critical"
                  detailsText="RELOAD THE PAGE"
                  onDetailsClick={() => window.location.reload()}
                >
                    <ContactUsMessage>{CheckoutUILabels.IF_ISSUE_PERSISTS}</ContactUsMessage>
                </Notification>
              </Grid.Column>
            </Grid.Row>);
        } else {
          errorObj = (<TaxStatusMessage severity={CheckoutUILabels.NOTIFICATION_SEVERITY_CRITICAL} />);
        }
        return errorObj;
    }


    render() {
        // console.log("isFetchingCartList from Review", this.props.isFetchingCartList);
        // console.log("isSuccessCartList from Review", this.props.isSuccessCartList);
        // console.log("checkInsideReviewOrder from Review----", this.props.checkInsideReviewOrder.data);
        
        
        return (
            <React.Fragment>
                {this.props.isOrderRequestInProgress &&
                    <GenericLoader
                        text="Placing Your Order Request"
                        className="features--loader"
                        loading={true}
                        overlayColor="rgb(247, 247, 247)" />}
                {this.renderModal()}
            </React.Fragment>
        );
    }

    renderModal() {
        /* checks the user allowed to access this component.       */
        const breadcrumbsList: Array<IBreadcrumbLink> = [
            { location: RouteNames.PURCHASE_SOFTWARE },
            { location: RouteNames.MY_CART },
            { location: RouteNames.SHIPPING_BILLING },
            { location: RouteNames.REVIEW_ORDER }
        ];
        let errorObj = this.errorContent();
        return (
            <Layout>

                {/******************body of the page  starts here*************/}
                {this.props.isFetchingCartList &&
                <GenericLoader
                    text="Fetching cart details"
                    className="features--loader"
                    loading={true}
                    overlayColor="rgb(247, 247, 247)" />}
                {errorObj}
                <Grid.Row >
                    <Grid.Column width={12} className="fullwidthRow" >
                        <Grid className="review-order-page">
                            <Grid.Row>
                                <Grid.Column width={12} className="heading-padding">
                                    <BreadcrumbComponent breadcrumbs={breadcrumbsList}/>
                                </Grid.Column>
                            </Grid.Row>
                            <Grid.Row className="fullwidthRow">
                                <Grid.Column width={12} className="heading-padding">
                                    <h1 className="centerAlign pageHeading">Review Order</h1>
                                </Grid.Column>
                            </Grid.Row>

                            {/****************row 1 ends here*************/}
                            <Grid.Row className="fullwidthRow">
                                <Grid.Column width={9} mWidth={12} sWidth={12}>
                                    <Grid.Row>
                                        <Grid.Column width={12} className="review-order-info">
                                            <Card className="ro-bill-ship-info-card">
                                                <Card.Content>
                                                    <Grid.Row>
                                                        <Grid.Column width={12} className="bill-heading">
                                                            <h3 className="ship-bill-info-text column-padding">Billing &amp; Shipping Information</h3>
                                                        </Grid.Column>
                                                    </Grid.Row>
                                                    <ShippingAndBillingInfoComponent />
                                                </Card.Content>
                                            </Card>
                                        </Grid.Column>
                                    </Grid.Row>
                                    <Grid.Row>
                                        <Grid.Column width={12} className="card-details-info">
                                            <ProductList page="reviewOrder" />
                                        </Grid.Column>
                                    </Grid.Row>
                                </Grid.Column>
                                {/******************first card  ends here*************/}

                                <Grid.Column width={3} mWidth={12} sWidth={12} className='order-summary-panel'>
                                    <OrderSummery>
                                        <div >
                                            <div className="ro-terms-div">
                                                <Checkbox
                                                    id="tncCheckbox"
                                                    className="ro-checkbox"
                                                    checked={this.state.TnCStatus}
                                                    onChange={this.updatePlaceOrderButtonStatus}
                                                    data-testid="tnccheckbox"
                                                />
                                                <div className="terms-check col-12">
                                                    I agree to the HII Conditions of Sale located &nbsp;
                                                    <a href={this.state.TnCUrl} target="_blank" rel="noopener">here</a>
                                                </div>
                                            </div>
                                            {this.state.TnCErrorMsg && <div className="below-text col-12 tncError"><span className="ui error-message">{this.state.TnCErrorMsg}</span></div>}
                                            <Button
                                                type="primary"
                                                id="placeOrder-btn"
                                                content="PLACE ORDER"
                                                className="fullWidthButton co-primary-button placeOrder"
                                                onClick={this.placeOrder}
                                                data-testid="placeOrder"
                                                disabled={!this.props.taxSuccessOrFailure || (!this.props.isFetchingCartList && !this.props.isSuccessCartList)}
                                            />
                                        </div>
                                    </OrderSummery>
                                </Grid.Column>
                            </Grid.Row>
                        </Grid>
                    </Grid.Column>
                </Grid.Row>
            </Layout>
        );
    }
}

// const mapDispatchToProps = {
//     insideReviewOrder: ReviewOrderActions.insideReviewOrder,
//   };

function mapStateToProps(state) {
    const { isFetching, isSuccess, taxSuccessOrFailure } = state.orderSummary.orderSummary;
    const { itemCount } = state.orderSummary.orderSummary?.data;
    const isFetchingCartList = state.cartDetails.selectedCartList?.isFetching;
    const isSuccessCartList = state.cartDetails.selectedCartList?.isSuccess;
    const checkInsideReviewOrder1 = state.reviewOrderData?.reviewOrderData;
    const checkInsideReviewOrder = checkInsideReviewOrder1;

    if (!isFetching && isSuccess) {
        return {
            orderReference: state.placeOrderRequestData.payload.orderReference,
            isOrderRequestInProgress: state.placeOrderRequestData.payload.isOrderRequestInProgress,
            taxSuccessOrFailure: taxSuccessOrFailure,
            itemCount: itemCount,
            isFetching,
            isSuccess,
            isFetchingCartList,
            isSuccessCartList,
            checkInsideReviewOrder
        };
    }
    else {
        return {
            orderReference: state.placeOrderRequestData.payload.orderReference,
            isOrderRequestInProgress: state.placeOrderRequestData.payload.isOrderRequestInProgress,
            isFetching,
            isSuccess,
            isFetchingCartList,
            isSuccessCartList,
            checkInsideReviewOrder
        };
    }
}

export default connect(mapStateToProps,
                       {
        placeOrderRequest: PlaceOrderRequestActions.placeOrderRequest,
        insideReviewOrder: ReviewOrderActions.insideReviewOrder,
    }
)(withRouter(ReviewOrder));
